"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../../utils");
var _actions = require("../../../actions");
function sourceOrderChanged(_ref, _ref2) {
  var dispatch = _ref.dispatch,
    getState = _ref.getState;
  var presenterId = _ref2.presenterId,
    isPresenterSource = _ref2.isPresenterSource,
    notifyingDirector = _ref2.notifyingDirector;
  if (!(0, _utils.isSameAttendee)(notifyingDirector, getState())) {
    if (isPresenterSource) {
      dispatch((0, _actions.syncFeaturedPresenter)(presenterId));
    } else {
      // sync sources
      dispatch((0, _actions.getSources)());
    }
  }
}
var _default = exports["default"] = sourceOrderChanged;